var plugin_rtlignore_default = {
  "alignLeft": "_3k-Gy",
  "textWrapNowrap": "cefYj",
  "alignRight": "JWarE",
  "alignCenter": "xTdoc",
  "sizeFullWidth": "Ib-Y-",
  "renderedInTable": "wIIFM",
  "sizeOriginal": "IYupO",
  "sizeContent": "qrau-",
  "sizeSmall": "jbVh0",
  "sizeSmallCenter": "_19SYt",
  "flex": "jV9n3",
  "atomic": "OdElK",
  "embed": "_6pS7m",
  "horizontalScrollbar": "_2vew-",
  "pluginContainerMobile": "OKsS0"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
